


















import Vue, { PropType } from 'vue';
import contact, { SnapShot, Contact, createNewContact } from '@/modules/contact/contact';

export type DataType = {
  contactId: string | null;
  isContacted: boolean;
  snapshot: any;
  isMounted: boolean;
  isLoading: boolean;
};

export default Vue.extend({
  name: 'GContactbutton',
  props: {
    brandId: {
      type: String as PropType<string>,
      required: true,
    },
    exhibitorCId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data(): DataType {
    return {
      contactId: null,
      isContacted: false,
      snapshot: new SnapShot(),
      isMounted: false,
      isLoading: false,
    };
  },
  watch: {
    async '$auth.cid'() {
      await this.initialyzeContact();
    },
  },
  async mounted() {
    await this.initialyzeContact();
    this.$nextTick(() => {
      this.isMounted = true;
    });
  },
  destroyed() {
    this.snapshot.detach();
  },
  methods: {
    async initialyzeContact() {
      const brandId = this.brandId;
      const buyerCId = this.$auth.cid;
      const isSignedInExhibitor = this.$auth.isExhibitor;
      if (isSignedInExhibitor) return;
      if (!brandId) return;
      if (!buyerCId) return;
      this.snapshot.snapshot(
        buyerCId,
        brandId,
        (val: Contact) => {
          this.isContacted = !!val;
          if (val) {
            this.contactId = val.id;
          } else {
            this.contactId = null;
          }
          console.log(this.contactId);
        },
        (err: Error) => {
          throw new Error(err.message);
        },
      );
    },
    async onContact() {
      this.isLoading = true;
      this.$loading(true);
      try {
        const exhibitorCId = this.exhibitorCId;
        const brandId = this.brandId;
        const buyerCId = this.$auth.cid;
        const uid = this.$auth.uid;
        const isSignedInExhibitor = this.$auth.isExhibitor;
        const isSignedInBuyer = this.$auth.isBuyer;
        if (!isSignedInBuyer) {
          window.location.href = '/web/auth/signup?at=1';
          return;
        }
        if (isSignedInExhibitor) {
          this.$error('出展者からのお問い合わせはできません', null);
          return;
        }
        if (this.isContacted) {
          if (!this.contactId) return;
          this.$router.push({
            name: 'buyer-contact-chat',
            params: { id: this.contactId },
          });
          return;
        }
        if (!exhibitorCId || !brandId || !buyerCId || !uid) throw new Error('Can not params');
        // TODO: ここはモジュールにもっていく。
        const contactFrom: 'exhibitor' | 'buyer' = isSignedInExhibitor ? 'exhibitor' : 'buyer';
        const newContact = await createNewContact(
          exhibitorCId,
          buyerCId,
          brandId,
          contactFrom,
        );
        const res = await contact.save(uid, newContact);
        // TODO: ここはモジュールにもっていく。
        if (!res) throw new Error('Can not send contact');
        await this.$success('お問い合わせを完了しました');
        this.isContacted = true;
      } catch (error: any) {
        await this.$error('お問い合わせに失敗しました', error);
      } finally {
        this.isLoading = false;
        this.$loading(false);
      }
    },
  },
});
